import App from './components/App';

const app = new App('fancyWeather');

app.init();
